import React from "react";

import { DashboardPageTemplate } from "../../Utils/DashboardPageTemplate";

export const StatSigDashboard = () => {
  return <DashboardPageTemplate pageName={"statSig"} showCogsWarning={true} />;
};
